module.exports = __webpack_public_path__ + "img/login-elements.cbeac32b.png";